var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:[
    'articles__headline',
    {
      'articles__headline--festival': _vm.isFestivalYear,
    } ],style:({
    backgroundImage: _vm.isFestivalYear ? 'none' : ("url(" + _vm.listPageBanner + ")"),
  })},[_vm._v("\n  "+_vm._s(_vm.listTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }